module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-bldg-apart-big-cdfc97840641b925b4ef240675bd8500.png";